import { createContext, Dispatch, SetStateAction, useContext } from 'react';

import { BookmarkDTO } from './components/bookmark';

export interface BookmarkContextValue {
	setLabelsIds: Dispatch<SetStateAction<Array<string> | undefined>>;
	setNotes: Dispatch<SetStateAction<string | undefined>>;
	notes?: string;
	labelsIds?: Array<string>;
	setSuggestions: Dispatch<SetStateAction<Array<string> | undefined>>;
	suggestions?: Array<string>;
	referenceId: string;
	referenceText?: string;
	referenceType: string;
	bookmark?: BookmarkDTO;
	setBookmark: Dispatch<SetStateAction<BookmarkDTO | undefined>>;
	isModalOpen: boolean;
	onCloseModal: VoidFunction;
	onOpenModal: VoidFunction;
}

const BookmarkContext = createContext<BookmarkContextValue>(null as any);

export const BookmarkContextProvider = BookmarkContext.Provider;

export const useBookmark = () => {
	const value = useContext(BookmarkContext);

	if (!value) {
		throw new Error('Bookmark context not found. Did you wrap your component in <Bookmark />');
	}

	return value;
};
